export default __webpack_public_path__ + "static/media/train51.7dfbe4d8.png";